// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_oi-5";
export var filledCircle = "_oi-4";
export var historyEntry = "_oi-3";
export var messageSideLeft = "_oi-1";
export var messageSideRight = "_oi-2";
export var orderTrackingCarouselWrapper = "_oi-6";
export var orderTrackingInfoContainer = "_oi-0";